import { createFromIconfontCN } from '@ant-design/icons';
const MyIcon = createFromIconfontCN({
    // scriptUrl: 'https://at.alicdn.com/t/font_2254478_nhietfhykph.js' // 在 iconfont.cn 上生成
    scriptUrl: 'https://at.alicdn.com/t/font_2254478_5q5ja033r4u.js' // 在 iconfont.cn 上生成
});
export default MyIcon
